var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Group(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.16 28.34a19.429 19.429 0 00-37.985-4.373A19.43 19.43 0 0026 48.66a19.43 19.43 0 1023.2-20.32h-.04zm-34.81 1.27A15.44 15.44 0 0145.14 28a19.45 19.45 0 00-19 16.63 15.45 15.45 0 01-11.79-15.02zM45 32a15.44 15.44 0 01-14.9 13A15.44 15.44 0 0145 32zm.31 30.86A15.45 15.45 0 0130 49a19.45 19.45 0 0019-16.59 15.43 15.43 0 01-3.66 30.42l-.03.03z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Group.465785dd.svg";
export { SvgJ2Group as ReactComponent };